<template>
  <div class="form-group">
    <label class="control-label">{{ detail.detail_name }}</label>
    <el-select v-model="selectedId"
               placeholder="Search doctor by name"
               no-data-text="No match"
               filterable
               remote
               clearable
               reserve-keyword
               :remote-method="searchDoctors"
               :loading="loading"
               style="width:100%"
               @change="onChange"
               @clear="onChange">
      <el-option v-for="doctor in options"
                 :key="doctor.id"
                 :label="doctorLabel(doctor)"
                 :value="doctor.id">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import APIDoctors from '@/api/modules/doctors';

// doctor_id is a foreign key into the doctors catalog, but EntityDetails.vue's generic
// {detail_name, detail_value} loop has no way to know that — it rendered it as a bare number
// input, so editing it meant typing an id blind with no way to see or search by name.
export default {
  props: ['detail'],
  data: () => ({
    selectedId: null,
    options: [],
    loading: false,
  }),
  created() {
    this.resolveCurrentDoctor();
  },
  watch: {
    // The parent seeds `details` synchronously with defaults (doctor_id: '0') before
    // getEntity() resolves and replaces the array with the real saved value. EntityDetails.vue
    // keys this component by detail_name, which doesn't change between the two, so Vue patches
    // props on the SAME instance instead of remounting it — created() had already run and
    // skipped resolving a name for '0' by the time '270' arrived, and nothing re-triggered it.
    'detail.detail_value'(newValue) {
      if (Number(newValue) === this.selectedId) return;
      this.resolveCurrentDoctor();
    },
  },
  methods: {
    resolveCurrentDoctor() {
      const currentId = Number(this.detail.detail_value);
      if (!(currentId > 0)) {
        this.selectedId = null;
        return;
      }

      this.loading = true;
      APIDoctors.getDoctor(currentId)
        .then((response) => {
          if (response?.data?.id) {
            this.options = [response.data];
            this.selectedId = response.data.id;
          }
        })
        .finally(() => { this.loading = false; });
    },
    doctorLabel(doctor) {
      return `${doctor.name?.en || doctor.name?.ru || `#${doctor.id}`} (#${doctor.id})`;
    },
    searchDoctors(query) {
      if (!query) {
        this.options = [];
        return;
      }

      // hide must be sent as '0', not omitted or 'false' — the filter factory casts the raw
      // string with PHP's (bool), where 'false' is truthy. Left unset, the backend has no
      // opinion on hide at all and this would surface hidden doctors as pickable results.
      this.loading = true;
      APIDoctors.getDoctors({ name: query, hide: 0, 'per-page': 20 })
        .then((response) => {
          this.options = response?.data?.doctors || [];
        })
        .finally(() => { this.loading = false; });
    },
    onChange() {
      // detail_value is a string on the wire (illnesses_details.detail_value etc. are all
      // varchar) — clearing the select must fall back to '0', matching every other unset
      // detail in this app, not an empty string or null.
      this.detail.detail_value = this.selectedId ? String(this.selectedId) : '0';
    },
  },
}
</script>

